exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wabident-object-field__item{border-bottom:1px solid var(--theme-grey-bg);padding-top:10px;padding-bottom:10px}", ""]);

// exports
